const STORAGE_KEY_PREFIX = 'quickEntryDialog:';
const SNOOZE_DURATION_MS = 24 * 60 * 60 * 1000;

interface QuickEntryDismissalState {
  dontRemindAgain: boolean;
  snoozedUntil: number | null;
}

function storageKey(userId: string): string {
  return `${STORAGE_KEY_PREFIX}${userId}`;
}

function readState(userId: string): QuickEntryDismissalState {
  try {
    const raw = localStorage.getItem(storageKey(userId));
    if (!raw) {
      return {dontRemindAgain: false, snoozedUntil: null};
    }
    const parsed = JSON.parse(raw);
    return {
      dontRemindAgain: !!parsed.dontRemindAgain,
      snoozedUntil: typeof parsed.snoozedUntil === 'number' ? parsed.snoozedUntil : null,
    };
  } catch (e) {
    return {dontRemindAgain: false, snoozedUntil: null};
  }
}

function writeState(userId: string, state: QuickEntryDismissalState): void {
  try {
    localStorage.setItem(storageKey(userId), JSON.stringify(state));
  } catch (e) {
    // Storage unavailable (private browsing, quota) — dialog just reappears next session.
  }
}

export function isQuickEntryDialogSuppressed(userId: string, now: number = Date.now()): boolean {
  const state = readState(userId);
  return state.dontRemindAgain || (state.snoozedUntil !== null && state.snoozedUntil > now);
}

export function snoozeQuickEntryDialogForOneDay(userId: string, now: number = Date.now()): void {
  const state = readState(userId);
  writeState(userId, {...state, snoozedUntil: now + SNOOZE_DURATION_MS});
}

export function dismissQuickEntryDialogForever(userId: string): void {
  const state = readState(userId);
  writeState(userId, {...state, dontRemindAgain: true});
}
